// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".where-is-my-data[data-v-9c17b53e]{fill:var(--color-text-lighter)}", "",{"version":3,"sources":["webpack://./src/components/Location.vue"],"names":[],"mappings":"AACA,mCACC,8BAAA","sourcesContent":["\n.where-is-my-data {\n\tfill: var(--color-text-lighter);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
